import React from 'react';
import { SnackbarContent, useSnackbar } from 'notistack';
import { Avatar, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { Notification } from '../icons';
import Typography from '../typography/typography';
import images from '../../assets/images';
import "./custom-snackbar.scss"

interface CustomSnackbarProps {
  message: string;
  variant?: 'default' | 'error' | 'success' | 'warning' | 'info';
  linkUrl?: string;
  snackbarKey: string | number;
}

const mainModuleIcons = {
  rbac: images.user,
  document: images.document,
  'accounts-and-finance': images.accounting,
  inventory: images.inventory,
  manufacturing: images.manufacturing,
  sales: images.crm,
  rental: images.rental,
  user: images.user,
  purchase: images.procurement,
  hrms: images.hrms
}
const mainModuleBgColors = {
  rbac: '#F3E5F5',
  document: '#FFF8E1',
  'accounts-and-finance': '#E8F5E8',
  inventory: '#E3F2FD',
  manufacturing: '#FFF3E0',
  sales: '#F3E5F5',
  rental: '#E8F5E8',
  user: '#F3E5F5',
  purchase: '#FCE4EC',
  hrms: '#fcfcfc'
}

const CustomSnackbar = React.forwardRef<HTMLDivElement, CustomSnackbarProps>(
  ({ message, variant = 'default', linkUrl, snackbarKey, data }, ref) => {
    const { closeSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const backgroundColorMap: Record<string, string> = {
      success: '#f0fdf4',
      error: '#fef2f2',
      warning: '#fff7ed',
      info: '#eff6ff',
      default: '#fff',
    };

    const textColorMap: Record<string, string> = {
      success: '#166534',
      error: '#991b1b',
      warning: '#92400e',
      info: '#1e40af',
      default: '#27272a',
    };

    const handleClick = () => {
      if (linkUrl) navigate(linkUrl);
      closeSnackbar(snackbarKey);
    };

    const handleCloseClick = (e: React.MouseEvent) => {
      e.stopPropagation(); // Prevent triggering link
      closeSnackbar(snackbarKey);
    };

    return (
      <SnackbarContent
        ref={ref}
        style={{
          backgroundColor: backgroundColorMap[variant],
          color: textColorMap[variant],
        }}
        className='SnackBar'
        onClick={handleClick}
      >
        <Box display="flex" alignItems="center" p={2} position="relative" gap={2} width='100%'>
        {mainModuleIcons?.[data.module] ?
          <Avatar sx={{ 
            width: 45, 
            height: 45, 
            fontSize: '0.875rem',
            bgcolor: mainModuleBgColors[data.module] || 'primary.main',
            color: 'white',
            borderRadius: '8px',
            '& img': { 
              width: '35px', 
              height: '35px', 
              objectFit: 'contain'
            }
          }} src={mainModuleIcons?.[data.module]} /> :
          <Notification
            style={{
              color: textColorMap[variant],
              marginTop: 2,
            }}
          />
        }
          <Box display="flex" alignItems="center" width='100%'>
            <Box flex="1">
              <Typography type='h5' color={'inherit'} weight='bold'>
                New Notification
              </Typography>
              <Typography type='s3' mt={0.5} color={'inherit'}>
                {message}
              </Typography>
            </Box>

            <IconButton
              size="small"
              onClick={handleCloseClick}
              // style={{
              //   position: 'absolute',
              //   top: 4,
              //   right: 4,
              //   color: textColorMap[variant],
              // }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </SnackbarContent>
    );
  }
);

export { CustomSnackbar };
export default CustomSnackbar;
